import React from 'react'
import { Link } from 'react-router-dom';

const VideoCard = ({ video: { id: { videoId }, snippet } }) => {
  
  return (

    <>
      <div className="card h-100 "  id="cardWidthSet" >
        <Link to={ `/video/${videoId}` } className=' text-decoration-none '>
        <img src={snippet?.thumbnails?.high?.url} className="card-img-top" alt="images" height={'170px'} width={'300px'} />
        
          <p className="card-text link-dark py-0 ms-1 text-wrap">{snippet?.title.slice(0,60)}</p>
        
        </Link>

        <Link to={ `/channel/${snippet.channelId}`} className=' text-decoration-none link-secondary ms-1  '>
              <p>{snippet?.channelTitle} </p>
            
        </Link>
     
      </div>
    </>
  )
}

export default VideoCard
